import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected, } from '@reduxjs/toolkit';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { ITireCpkDashboard, ITireCpkItem, defaultDashboardValue, } from 'app/shared/model/tire-cpk-dashboard.model';

export interface TireCpkDashboardState {
  dashboardLoading: boolean;
  itemsLoading: boolean;

  errorMessage: string | null;

  dashboard: ITireCpkDashboard;

  cpkItems: ITireCpkItem[];
}

const initialState: TireCpkDashboardState = {
  dashboardLoading: false,
  itemsLoading: false,

  errorMessage: null,

  dashboard: defaultDashboardValue,

  cpkItems: [],
};

const dashboardApiUrl = '/api/tire-cpk-data';

const itemsApiUrl = '/api/tire-cpk-all';

export const getTireCpkDashboard = createAsyncThunk(
  'tireCpkDashboard/fetch_dashboard',
  async (filters?: any) => {
    return axios.get<ITireCpkDashboard>(dashboardApiUrl, {
      params: filters,
    });
  },
  {
    serializeError: serializeAxiosError,
  }
);

export const getTireCpkItems = createAsyncThunk(
  'tireCpkDashboard/fetch_items',
  async (filters?: any) => {
    return axios.get<ITireCpkItem[]>(itemsApiUrl, {
      params: filters,
    });
  },
  {
    serializeError: serializeAxiosError,
  }
);

export const TireCpkDashboardSlice = createSlice({
  name: 'tireCpkDashboard',

  initialState,

  reducers: {
    reset() {
      return initialState;
    },
  },

  extraReducers(builder) {
    builder

      .addMatcher(
        isPending(
          getTireCpkDashboard
        ),
        state => {
          state.dashboardLoading = true;
          state.errorMessage = null;
        }
      )

       .addMatcher(
        isPending(
          getTireCpkItems
        ),
        state => {
          state.itemsLoading = true;
          state.errorMessage = null;
        }
      )

      .addMatcher(
        isFulfilled(getTireCpkDashboard),
        (state, action) => {
          state.dashboardLoading = false;

          state.dashboard = {
            byFunction:
              action.payload.data.byFunction ?? [],

            byVehicleType:
              action.payload.data.byVehicleType ?? [],

            byMonthByFunction:
              action.payload.data.byMonthByFunction ?? [],

            byMonthByVehicleType:
              action.payload.data.byMonthByVehicleType ?? [],
          };
        }
      )

      .addMatcher(
        isFulfilled(getTireCpkItems),
        (state, action) => {
          state.itemsLoading = false;

          state.cpkItems = action.payload.data ?? [];
        }
      )

            .addMatcher(
        isRejected(
          getTireCpkDashboard
        ),
        (state, action) => {
          state.dashboardLoading = false;

          state.errorMessage =
            action.error.message ??
            'Erro ao carregar dados';
        }
      )

      .addMatcher(
        isRejected(
          getTireCpkItems
        ),
        (state, action) => {
          state.itemsLoading = false;

          state.errorMessage =
            action.error.message ??
            'Erro ao carregar dados';
        }
      );
  },
});

export const { reset } =
  TireCpkDashboardSlice.actions;

export default TireCpkDashboardSlice.reducer;